import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import asyncComponent from 'util/asyncComponent';
import DateRangePicker from 'components/kea/DateRangePicker';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import { changeTimeframe } from 'actions';
import SafetyRoute from 'components/kea/SafetyRoute';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import RecsAnalyticsWidgetsPerformance from './RecsAnalyticsWidgetsPerformance/index';

const Analytics = ({ match }) => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { timeframe } } = useSelector(store => store);
  const onTimeframeSubmit = newRange => dispatch(changeTimeframe(newRange));

  return (
    <FeaturePageShell
      title={localizeMessage('recs.analytics')}
      description={localizeMessage('recs.analytics.description')}
      width="expanded"
      actions={<DateRangePicker timeframe={timeframe} onSubmitRange={onTimeframeSubmit} />}
    >
      <Switch>
        <SafetyRoute path={`${match.url}/widgets-performance`}>
          <RecsAnalyticsWidgetsPerformance />
        </SafetyRoute>
        <Route component={asyncComponent(() => import('app/routes/404'))} />
      </Switch>
    </FeaturePageShell>
  );
};

export default Analytics;
